import { createSvgIcon } from "@mui/material";

const STATE_1 = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM2.17491 8C2.17491 11.2171 4.78289 13.8251 8 13.8251C11.2171 13.8251 13.8251 11.2171 13.8251 8C13.8251 4.78289 11.2171 2.17491 8 2.17491C4.78289 2.17491 2.17491 4.78289 2.17491 8Z"
      fill="#E2E6E9"
    />
    <path
      d="M8 0C9.01707 1.21284e-08 10.0248 0.193939 10.9692 0.571426L10.162 2.59098C9.47433 2.31612 8.74056 2.17491 8 2.17491V0Z"
      fill="#4763F4"
    />
  </svg>,
  "state 1"
);

const STATE_2 = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM2.17491 8C2.17491 11.2171 4.78289 13.8251 8 13.8251C11.2171 13.8251 13.8251 11.2171 13.8251 8C13.8251 4.78289 11.2171 2.17491 8 2.17491C4.78289 2.17491 2.17491 4.78289 2.17491 8Z"
      fill="#E2E6E9"
    />
    <path
      d="M8 0C9.1969 1.42729e-08 10.3785 0.268565 11.4579 0.785903C12.5372 1.30324 13.4867 2.05617 14.2363 2.9892C14.986 3.92223 15.5168 5.01159 15.7895 6.177C16.0623 7.34241 16.07 8.55417 15.8123 9.72298L13.6884 9.25456C13.8761 8.40351 13.8704 7.52118 13.6718 6.67261C13.4732 5.82403 13.0868 5.03083 12.5409 4.35145C11.995 3.67208 11.3037 3.12385 10.5178 2.74715C9.7319 2.37046 8.87151 2.17491 8 2.17491V0Z"
      fill="#4763F4"
    />
  </svg>,
  "state 2"
);

const STATE_3 = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM2.17491 8C2.17491 11.2171 4.78289 13.8251 8 13.8251C11.2171 13.8251 13.8251 11.2171 13.8251 8C13.8251 4.78289 11.2171 2.17491 8 2.17491C4.78289 2.17491 2.17491 4.78289 2.17491 8Z"
      fill="#E2E6E9"
    />
    <path
      d="M8 0C9.40988 1.68127e-08 10.7947 0.372595 12.0143 1.08005C13.2338 1.7875 14.2447 2.80468 14.9446 4.02857C15.6445 5.25245 16.0086 6.63957 15.9998 8.04942C15.9911 9.45927 15.61 10.8418 14.895 12.0569C14.18 13.2721 13.1566 14.2767 11.9285 14.969C10.7003 15.6613 9.31094 16.0168 7.90117 15.9994C6.49139 15.982 5.11126 15.5923 3.90056 14.8698C2.68985 14.1474 1.69158 13.1178 1.00685 11.8853L2.90803 10.8291C3.40661 11.7264 4.13349 12.4761 5.01505 13.0022C5.8966 13.5282 6.90153 13.812 7.92803 13.8246C8.95454 13.8373 9.96617 13.5785 10.8605 13.0744C11.7547 12.5703 12.4999 11.8388 13.0205 10.954C13.5411 10.0692 13.8186 9.06255 13.825 8.03598C13.8313 7.00942 13.5663 5.99941 13.0566 5.10825C12.547 4.2171 11.8109 3.47645 10.9229 2.96133C10.0349 2.44621 9.02658 2.17491 8 2.17491V0Z"
      fill="#4763F4"
    />
  </svg>,
  "state 3"
);

const STATE_4 = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM2.17491 8C2.17491 11.2171 4.78289 13.8251 8 13.8251C11.2171 13.8251 13.8251 11.2171 13.8251 8C13.8251 4.78289 11.2171 2.17491 8 2.17491C4.78289 2.17491 2.17491 4.78289 2.17491 8Z"
      fill="#E2E6E9"
    />
    <path
      d="M8 0C9.99585 2.38002e-08 11.9196 0.746034 13.3936 2.09164C14.8677 3.43725 15.7855 5.28525 15.9669 7.27283C16.1483 9.26042 15.5802 11.244 14.3742 12.8343C13.1681 14.4245 11.4112 15.5065 9.44832 15.8678C7.48545 16.2291 5.45841 15.8437 3.76514 14.7872C2.07186 13.7307 0.83466 12.0794 0.29641 10.1575C-0.241839 8.23558 -0.0422572 6.1819 0.855974 4.3996C1.75421 2.6173 3.28621 1.23512 5.15123 0.524407L5.9257 2.55675C4.56772 3.07424 3.45221 4.08066 2.79817 5.37842C2.14414 6.67617 1.99882 8.17153 2.39073 9.57094C2.78265 10.9703 3.68351 12.1727 4.91644 12.942C6.14938 13.7113 7.62534 13.9919 9.05457 13.7288C10.4838 13.4657 11.7631 12.6779 12.6413 11.52C13.5194 10.3621 13.9331 8.91775 13.801 7.47052C13.6689 6.02329 13.0006 4.6777 11.9273 3.69791C10.854 2.71812 9.45325 2.17491 8 2.17491V0Z"
      fill="#4763F4"
    />
  </svg>,
  "state 4"
);

const STATE_5 = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM2.17491 8C2.17491 11.2171 4.78289 13.8251 8 13.8251C11.2171 13.8251 13.8251 11.2171 13.8251 8C13.8251 4.78289 11.2171 2.17491 8 2.17491C4.78289 2.17491 2.17491 4.78289 2.17491 8Z"
      fill="#01A902"
    />
    <svg xmlns="http://www.w3.org/2000/svg" x="4" y="4" width="8" height="8" viewBox="0 0 8 8" fill="none">
      <path
        d="M7.2653 2.51565L3.2653 6.51565C3.23046 6.55061 3.18906 6.57835 3.14348 6.59728C3.0979 6.6162 3.04903 6.62595 2.99967 6.62595C2.95032 6.62595 2.90145 6.6162 2.85587 6.59728C2.81028 6.57835 2.76889 6.55061 2.73405 6.51565L0.984049 4.76565C0.949167 4.73077 0.921496 4.68936 0.902618 4.64378C0.88374 4.5982 0.874023 4.54936 0.874023 4.50003C0.874023 4.45069 0.88374 4.40185 0.902618 4.35627C0.921496 4.31069 0.949167 4.26928 0.984049 4.2344C1.01893 4.19952 1.06034 4.17185 1.10592 4.15297C1.15149 4.13409 1.20034 4.12437 1.24967 4.12437C1.29901 4.12437 1.34785 4.13409 1.39343 4.15297C1.43901 4.17185 1.48042 4.19952 1.5153 4.2344L2.99999 5.71909L6.73467 1.98503C6.80512 1.91458 6.90067 1.875 7.0003 1.875C7.09993 1.875 7.19548 1.91458 7.26592 1.98503C7.33637 2.05547 7.37595 2.15102 7.37595 2.25065C7.37595 2.35028 7.33637 2.44583 7.26592 2.51628L7.2653 2.51565Z"
        fill="#01A902"
      />
    </svg>
  </svg>,
  "state 5"
);

const GET_FRAME = (prog: number) => {
  if (prog <= 0.2) return <STATE_1 />;
  else if (prog <= 0.4) return <STATE_2 />;
  else if (prog <= 0.6) return <STATE_3 />;
  else if (prog <= 0.8) return <STATE_4 />;
  else return <STATE_5 />;
};

function FileUploadCircleState({ progress }: { progress: number }) {
  return GET_FRAME(progress);
}

export default FileUploadCircleState;
